<template>
   <div>
     <keep-alive>
      <router-view/>
     </keep-alive>
    <KakaoPopup/>
   </div>
</template>

<script>
import index from './views/app/index'
import KakaoPopup from "@/container/KakaoPopup";
export default {
  name: 'App',
  components: {
    KakaoPopup,
    index
  },
}
</script>

<style>

</style>
